import { render } from "./PestAndDiseaseRadarIcon.vue?vue&type=template&id=1688e7d5"
import script from "./PestAndDiseaseRadarIcon.vue?vue&type=script&lang=js"
export * from "./PestAndDiseaseRadarIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__